import React from 'react';
import { useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import './style.scss';

export const KidsTooltipContent = () => {
  const translations = useSelector(state => state.translations);

  return (
    <div className="kids-tooltip-content">
      <span className="kids-tooltip-content__title">
        {getTranslation('kids_tooltip_title_label', translations)}
      </span>
      <ul className="kids-tooltip-content__list">
        <li className="kids-tooltip-content__list__item">
          {getTranslation(
            'kids_tooltip_parentalRestriction_label_validation',
            translations,
          )}
        </li>
        <li className="kids-tooltip-content__list__item">
          {getTranslation(
            'kids_tooltip_additionalRestrictions_label_validation',
            translations,
          )}
        </li>
      </ul>
    </div>
  );
};
